import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { PROFILE_ROLES_PREFIX, RENEWAL_SPAN_CODE } from '../../core/utils/constants'
import "./style.scss";
import SearchBox from './SearchBox';
import { observer, inject } from "mobx-react";

@inject("commonStore")
@observer
class ProfileUser extends Component {
  // 年契約の期間を計算する関数
  calculateYearPeriod = () => {
    const { t, commonStore: { userStore: { userInfo } } } = this.props;
    const start = new Date(userInfo.useStartDate);
    const startYear = start.getFullYear();
    const startMonth = start.getMonth() + 1;
    const end = new Date(userInfo.useEndDate);
    const endYear = end.getFullYear();
    const endMonth = end.getMonth() + 1;

    return `${startYear}${t("profile.period_of_use.span.year")}
      ${String(startMonth).padStart(2, '0')}${t("profile.period_of_use.span.month")}
      ~
      ${endYear}${t("profile.period_of_use.span.year")}
      ${String(endMonth).padStart(2, '0')}${t("profile.period_of_use.span.month")}
    `;
  }

  isYear = () => {
    const { commonStore: { userStore: { userInfo } } } = this.props;
    return userInfo.contractRenewalSpan === RENEWAL_SPAN_CODE.YEAR
      && userInfo.startDate !== null
      && userInfo.startDate !== undefined;
  }

  render() {
    const { t, commonStore: { userStore: { userInfo } } } = this.props;
    const periodText = this.isYear() ? this.calculateYearPeriod() : '';

    return (
      <div className="box-body box-profile">
        <div className="row profile-item">
          <div className="col-sm-3">{t("profile.user_id")}</div>
          <div className="col-sm-9 profile-value">
            {userInfo.userId}
          </div>
        </div>
        <div className="row profile-item">
          <div className="col-sm-3">
            {t("profile.company_information")}
          </div>
          <div className="col-sm-9 profile-value">
            {userInfo.tenantName}
          </div>
        </div>
        <div className="row profile-item">
          <div className="col-sm-3">
            {t("profile.user_level")}
          </div>
          <div className="col-sm-9 profile-value">
            {t(PROFILE_ROLES_PREFIX + userInfo.role)}
          </div>
        </div>
        <div className="row profile-item">
          <div className="col-sm-3">
            {t("profile.number_of_contracts")}
          </div>
          <div className="col-sm-9 profile-value">
            {userInfo.contractAmount}{" "}
            <span>
              {userInfo &&
                userInfo.contractAmount &&
                userInfo.contractAmount > 1
                ? t("profile.sheets")
                : t("profile.sheet")}
            </span>
            <span>
              {" "}{userInfo &&
                userInfo.contractRenewalSpan &&
                userInfo.contractRenewalSpan == RENEWAL_SPAN_CODE.YEAR
                ? t("profile.per_year")
                : t("profile.per_month")}
            </span>
          </div>
        </div>
        <div className="row profile-item">
          <div className="col-sm-3">
            {this.isYear() ? t("profile.yearly_usage") : t("profile.monthly_usage")}
          </div>
          <div className="col-sm-3 profile-value">
            {userInfo.useAmount}{" "}
            <span>
              {userInfo &&
                userInfo.useAmount &&
                userInfo.useAmount > 1
                ? t("profile.sheets")
                : t("profile.sheet")}
            </span>
            {this.isYear() && periodText && (
              <div style={{ fontSize: '0.9em', color: '#666', marginTop: '4px' }}>
                {periodText}
              </div>
            )}
          </div>
          <SearchBox className="col-sm-6 amount-search-pannel" />
        </div>
      </div>
    );
  }
}

export default withTranslation()(ProfileUser);
